export default __webpack_public_path__ + "1727aba706fada62d04e44c1bd9d50d0.png";